export class ZipHelper {
  static async firstOrDefault(
    file: File,
    predicate: (filename: string, isDirectory: boolean) => boolean
  ): Promise<string | null> {
    const { ZipReader, BlobReader } = await import("@zip.js/zip.js");

    const zipReader = new ZipReader(new BlobReader(file));
    const entries = await zipReader.getEntries();

    const matchingEntry = entries.find((entry) =>
      predicate(entry.filename, entry.directory)
    );

    await zipReader.close();

    return matchingEntry?.filename || null;
  }
}

export async function findSingleHtmlFile(file: File): Promise<string | null> {
  return ZipHelper.firstOrDefault(
    file,
    (filename, isDirectory) => filename.endsWith(".html") && !isDirectory
  );
}
